import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class DepotsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'DEPOT_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // CREATE //
  createDuplicateIdError() {
    const message = {
      body: 'DEPOT_CREATE_DUPLICATE_ID_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  createError() {


    const message = {
      body: 'DEPOT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteSuccess() {
    const message = {
      body: 'DEPOT_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'DEPOT_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'DEPOT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'DEPOT_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET DRIVERS //
  getDriversError() {
    const message = {
      body: 'DEPOT_GET_DRIVERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET DRIVERS //
  getManyError() {
    const message = {
      body: 'DEPOT_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // GET ACCOUNTS //
  getAccountsError() {
    const message = {
      body: 'DEPOT_GET_ACCOUNTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.depots')
  .service('depotsAlerts', DepotsAlerts);
